import { render, staticRenderFns } from "./UserTemplatesData.vue?vue&type=template&id=5fb617e2"
import script from "./UserTemplatesData.vue?vue&type=script&lang=js"
export * from "./UserTemplatesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports